import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	MainHeaderButtonsWrapper: {
		display: "flex",
		alignItems: "center",
		flex: "none",
		marginLeft: "auto",
		flexWrap: "wrap",
		justifyContent: "flex-end",
		"& > *": {
			margin: theme.spacing(0.5),
		},
		[theme.breakpoints.down("xs")]: {
			width: "100%",
			marginLeft: 0,
			justifyContent: "flex-start",
		},
	},
}));

const MainHeaderButtonsWrapper = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.MainHeaderButtonsWrapper}>{children}</div>;
};

export default MainHeaderButtonsWrapper;
